import { t } from '../locales/i18nManager';

export type RouteInfo = {
  key: string;
  label?: string;
  route: string;
  routesGroup?: string;
  routeReload?: string;
  routeNoReload?: string;
};

// eslint-disable-next-line import/prefer-default-export
export const routes: {
  [key: string]: RouteInfo;
} = {
  welcome: {
    key: 'welcome',
    route: '/welcome',
  },
  login: {
    key: 'login',
    label: t('menu.login'),
    route: '/login',
  },
  register: {
    key: 'register',
    label: t('menu.register'),
    route: '/register',
  },
  onboarding: {
    key: 'onboarding',
    route: '/onboarding',
  },
  onboardingQuestionnaire: {
    key: 'onboardingQuestionnaire',
    route: '/onboarding-questionnaire',
  },
  passwordResetSendEmail: {
    key: 'passwordResetSendEmail',
    label: t('menu.passwordReset'),
    route: '/password-reset',
  },
  passwordReset: {
    key: 'passwordReset',
    label: t('menu.passwordReset'),
    route: '/password/reset/:uid/:token',
  },
  home: {
    key: 'home',
    label: t('menu.home'),
    route: '/',
    routesGroup: 'home',
  },
  messagingHome: {
    key: 'messagingHome',
    label: t('menu.messagingHome'),
    route: '/conversations',
    routeReload: '/conversations?reload=true',
    routeNoReload: '/conversations?reload=false',
    routesGroup: 'messaging',
  },
  messagingHowto: {
    key: 'messagingHowto',
    route: '/conversations-explainer',
    routesGroup: 'messaging',
  },
  conversation: {
    key: 'conversation',
    label: t('menu.conversation'),
    route: '/conversations/:conversationId',
    routeReload: '/conversations/:conversationId?reload=true',
    routesGroup: 'messaging',
  },
  conversationSummary: {
    key: 'conversationSummary',
    route: '/conversations/:conversationId/summary',
    routesGroup: 'messaging',
  },
  patientConversationsHistory: {
    key: 'patientConversationsHistory',
    route: '/conversations/:conversationId/history',
    routesGroup: 'messaging',
  },
  patientHistoricConversation: {
    key: 'patientConversationHistory',
    route: '/conversations/:conversationId/history/:historicConversation/',
    routesGroup: 'messaging',
  },
  historicConversationSummary: {
    key: 'historicConversationSummary',
    route: '/conversations/:conversationId/history/:historicConversation/summary',
    routesGroup: 'messaging',
  },
  newChat: {
    key: 'newChat',
    label: t('menu.newChat'),
    route: '/new-conversation',
    routesGroup: 'messaging',
  },
  newChatCheckup: {
    key: 'newChatCheckup',
    label: t('menu.newChat'),
    route: '/new-conversation?conversationType=checkup',
    routesGroup: 'messaging',
  },
  info: {
    key: 'info',
    label: t('menu.info'),
    route: '/info',
    routesGroup: 'info',
  },
  article: {
    key: 'article',
    route: '/article/:index',
  },
  caregiversDirectory: {
    key: 'caregiversDirectory',
    label: t('menu.caregiversDirectory'),
    route: '/caregivers',
    routesGroup: 'info',
  },
  faq: {
    key: 'faq',
    route: '/faq',
  },
  symptomTracking: {
    key: 'symptomTracking',
    label: t('menu.tracking'),
    route: '/track',
    routesGroup: 'tracking',
  },
  symptomTrackingSurvey: {
    key: 'symptomTrackingSurvey',
    route: '/track/survey',
    routesGroup: 'tracking',
  },
  settings: {
    key: 'settings',
    label: t('menu.settings'),
    route: '/settings',
  },
  logout: {
    key: 'logout',
    label: t('menu.logout'),
    route: '/logout',
  },
  notFound: {
    key: 'notFound',
    label: t('menu.notFound'),
    route: '*',
  },
  unauthorized: {
    key: 'unauthorized',
    label: t('menu.unauthorized'),
    route: '*',
  },
};
